import { AddressForm } from "./address_form";

export class GroupAddresses extends HTMLElement {
  constructor(data) {
    super();
    this.data = data;
  }

  connectedCallback() {
    this.innerHTML =
      `
      <style>
      .billing-frame {
        border radius: 8px !important;
        border: solid 1px #ccc;
      }

      .use_checkbox {
        padding-top: 12px;
      }

      @media only screen and (min-width: 1680px) {
        .use_checkbox {
          padding-left: 12px !important;
        }
      }


      </style>
      
      <div class="errors"></div>
      <div class="col-lg-6 col-md-12 contact_address_container">
        <h4>Contact Address</h4>
        
      </div>
      <div class="col-lg-6 col-md-12 billing_address_container billing-frame">
        <h4>Billing Address</h4>
        
      </div>
      <div class="col-lg-12">
        <div class="use_checkbox">
          <input type="checkbox" id="contact_address_checkbox" ${this.data.billing_address == null ? "checked":""}>
          <label>Use contact address as billing address</label>
        </div>

        <button id="contact_address_save" class="btn btn-primary pull-right">Save</button>
      </div>
      `;

    this.querySelector("#contact_address_save").addEventListener("click", function(e){e.preventDefault(); this.saveAddress()}.bind(this))
    this.querySelector('#contact_address_checkbox').addEventListener('click', function() {
      this.toggleAddress();
    }.bind(this))

    let contactAddress = new AddressForm(this.data.location_address);
    let billingAddress = new AddressForm(this.data.billing_address);
    this.querySelector('.contact_address_container').appendChild(contactAddress);
    this.querySelector('.billing_address_container').appendChild(billingAddress);

    this.toggleAddress();
  }

  async saveAddress() {
    if(!this.validate()) {
      return
    }

    let addresses = {
      contact_address: this.querySelector('.contact_address_container address-form').getData(),
      billing_address: !this.querySelector('#contact_address_checkbox').checked ? this.querySelector('.billing_address_container address-form').getData() : null
    };

    let res = await fetch(`/admin/groups/${this.data.id}/billing/addresses`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(addresses)
      })
    let data = await res.json();
    if(res.ok && data.success) {
      Common.notify("Successfully updated group.", 'success');
    }
  }

  toggleAddress() {
    if(this.querySelector('#contact_address_checkbox').checked) {
      this.querySelector('.billing_address_container').classList.add('hidden');
    } else {
      this.querySelector('.billing_address_container').classList.remove('hidden');
    }
  }

  validate() {
    let isValid = true;
    this.querySelector(".errors").innerHTML = '';
    if(!this.querySelector('#contact_address_checkbox').checked) {
      let contact = this.querySelector('.contact_address_container address-form').validate();
      let billing = this.querySelector('.billing_address_container address-form').validate();
      let errors = [contact.errors, billing.errors]
      let uniqueErrors = [...new Set(errors.flat())];
      let errorsComponent = uniqueErrors.map(error => {
        return `<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> ${error}
        </div>`;
      }).join('');

      this.querySelector(".errors").innerHTML = errorsComponent;

      if(!contact.isValid || !billing.isValid) {
        isValid = false;
      }
    } else {
      let contact = this.querySelector('.contact_address_container address-form').validate();
      let uniqueErrors = [...new Set(contact.errors)];
      let errorsComponent = uniqueErrors.map(error => {
        return `<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> ${error}
        </div>`;
      }).join('');

      this.querySelector(".errors").innerHTML = errorsComponent;

      if(!contact.isValid) {
        isValid = false;
      }

    }

    return isValid
  }
}

customElements.define('group-addresses', GroupAddresses)